import monetize from '@sdk/helpers/formatters/monetize';

import {
  boolean,
  select,
  input,
  file,
} from '@/_CRUDL/helpers/form/fields';

import { situationTypes } from '@/helpers/options/boolean';

import vehicleMap from './maps';

export default function sections() {
  return [{
    id: 'vehicleSettings',
    title: 'Configurações',
    subtitle: 'Defina as configurações desse veículo',
    items: [{
      ...boolean,
      id: vehicleMap.active,
      label: 'Situação',
      options: situationTypes,
      validations: [{
        type: 'blank',
      }],
    }, {
      ...boolean,
      id: vehicleMap.publish,
      label: 'Publicar na Loja online',
      validations: [{
        type: 'blank',
      }],
    }],
  }, {
    id: 'vehicleInformation',
    title: 'Informações',
    subtitle: 'Informe os atributos desse veículo',
    items: [{
      ...select,
      id: vehicleMap.type,
      label: 'Tipo',
      placeholder: 'Selecione',
      size: 2,
      validations: [{
        type: 'blank',
      }],
    }, {
      id: 'vehicleTypeSeparator',
      separator: true,
    }, {
      ...select,
      id: vehicleMap.fuel,
      label: 'Combustível',
      placeholder: 'Selecione',
      size: 2,
      validations: [{
        type: 'blank',
      }],
    }, {
      ...select,
      id: vehicleMap.brand,
      label: 'Marca',
      placeholder: 'Selecione',
      size: 2,
      validations: [{
        type: 'blank',
      }],
    }, {
      id: 'vehicleBrandSeparator',
      separator: true,
    }, {
      ...input,
      id: vehicleMap.name,
      label: 'Nome',
      placeholder: 'Insira o nome do veículo',
      size: 2,
      validations: [{
        type: 'blank',
      }],
    }, {
      ...input,
      id: vehicleMap.version,
      label: 'Versão',
      placeholder: 'Insira a versão do veículo',
      size: 2,
      validations: [{
        type: 'blank',
      }],
    }, {
      id: 'vehicleNameSeparator',
      separator: true,
    }, {
      ...select,
      id: vehicleMap.year_start,
      label: 'Ano modelo inicial',
      placeholder: 'Selecione',
      size: 2,
      validations: [{
        type: 'blank',
      }],
    }, {
      ...select,
      id: vehicleMap.year_end,
      label: 'Ano modelo final',
      placeholder: 'Selecione',
      size: 2,
      validations: [{
        type: 'blank',
      }],
    }, {
      id: 'vehicleYearSeparator',
      separator: true,
    }, {
      ...input,
      id: vehicleMap.molicar_code,
      label: 'Código Molicar',
      placeholder: 'Insira o código Molicar',
      size: 2,
      validations: [{
        type: 'blank',
      }],
    }, {
      ...input,
      id: vehicleMap.fipe_code,
      label: 'Código Fipe',
      placeholder: 'Insira o código Fipe',
      size: 2,
      validations: [{
        type: 'blank',
      }],
    }, {
      id: 'vehicleMolicarCodeSeparator',
      separator: true,
    }, {
      ...input,
      id: vehicleMap.price_cents,
      label: 'Preço público sugerido',
      mask: {
        type: 'monetize',
      },
      placeholder: 'R$ 0,00',
      validations: [{
        type: 'greaterThan',
        count: 0,
        formatter: monetize,
      }],
    }],
  }, {
    id: 'vehicleFiles',
    title: 'Arquivos',
    subtitle: 'Adicione aqui a imagem do veículo',
    items: [{
      ...file,
      id: vehicleMap.picture,
      label: 'Imagem do veículo',
      subdomain: 'Vehicle',
      qrCode: false,
      validations: [],
      size: 2,
    }],
  }];
}
